import React from "react";
import {
  ChecklistItemCard,
  ChecklistItemCardProps,
} from "./ChecklistItemCard";

export type ApprovedChecklistItemCardProps = Omit<
  ChecklistItemCardProps,
  "variant"
>;

export const ApprovedChecklistItemCard: React.FC<
  ApprovedChecklistItemCardProps
> = (props) => {
  return <ChecklistItemCard {...props} variant="approved" />;
};
